import { useEffect, useRef, useState, createRef } from 'react'
import { useHistory } from 'react-router-dom'
import classNames from 'classnames'
import gsap from 'gsap'
import { createUseStyles } from 'react-jss'
import SplitText from '@/vendors/bonus-files-for-npm-users/umd/SplitText' // eslint-disable-line
import BtnLink from '@/components/BtnLink'
import SimpleSplitText from '@/components/SimpleSplitText'
import SimpleMedia from '@/components/SimpleMedia'
import style from './style'

const useStyles = createUseStyles(style)

const CoverProduct = ({
  altImg,
  className,
  denomination,
  mainImg,
  onComplete,
  subtitle,
  title,
}) => {
  const classes = useStyles()
  const $titles = useRef([1, 2].map(() => createRef()))
  const $titleLines = useRef()
  const $backBtn = useRef()
  const $denomination = useRef([1, 2].map(() => createRef()))
  const $denominationLines = useRef()
  const $subtitle = useRef()
  const $line = useRef()
  const $mainImg = useRef()
  const $altImg = useRef()
  const history = useHistory()
  const [ready, setReady] = useState(false)
  const [removeOverflow, setRemoveOverflow] = useState(false)

  const fadeIn = (ref, duration = 1.2) => {
    gsap.to(ref, { opacity: 1, ease: 'power3.out', duration })
  }

  const prepareAnimation = () => {
    if (title !== undefined && title !== '') {
      $titleLines.current = new SplitText($titleLines.current, { type: 'lines' })
    }
    if (denomination !== undefined && denomination !== '') {
      $denominationLines.current = new SplitText($denominationLines.current, { type: 'lines' })
    }
    setReady(true)
  }

  useEffect(() => {
    prepareAnimation()
  }, [])

  useEffect(() => {
    if (ready) {
      if ($titles.current.length > 0) setTimeout(() => $titles.current.map((t) => t.current?.animateIn()), 500)
      if ($denomination.current.length > 0) setTimeout(() => $denomination.current.map((t) => t.current?.animateIn()), 800)
      if ($subtitle.current) setTimeout(() => $subtitle.current.animateIn(), 1000)
      if ($line.current) {
        setTimeout(() => {
          gsap.to($line.current, {
            scaleX: 1,
          })
        }, 1000)
      }
      if ($backBtn.current) setTimeout(() => fadeIn($backBtn.current), 1000)
      if ($mainImg.current) setTimeout(() => $mainImg.current.animateIn(), 1100)
      if ($altImg.current) setTimeout(() => $altImg.current.animateIn(), 1200)
      if (onComplete) {
        setTimeout(() => {
          onComplete()
          setRemoveOverflow(true)
        }, 2000)
      }
    }
  }, [ready])

  return (
    <div
      className={classNames({
        [classes.root]: true,
        [className]: className,
      })}
    >
      <div className={classes.wrapper}>
        <BtnLink
          ref={$backBtn}
          className={classes.backBtn}
          onClick={() => history.goBack()}
          label="Indietro"
          theme="dark"
        />
        <div className={classes.titleWrapper}>
          <span
            className={`${classes.titleHidden} ${classes.hidden}`}
            ref={$titleLines}
          >
            {title}
          </span>
          {$titleLines.current?.lines.map((item, i) => (
            <SimpleSplitText
              key={i.toString()}
              className={classNames({
                [classes.title]: true,
                [classes.removeOverflow]: removeOverflow,
              })}
              ref={$titles.current[i]}
              text={item.innerText}
              disableHover
              animation="split"
              appear
            />
          ))}
        </div>
        <span
          className={`${classes.denominationHidden} ${classes.hidden}`}
          ref={$denominationLines}
        >
          {denomination}
        </span>
        {$denominationLines.current?.lines?.map((item, i) => (
          <SimpleSplitText
            key={i.toString()}
            className={classNames({
              [classes.denomination]: true,
              [classes.removeOverflow]: removeOverflow,
            })}
            ref={$denomination.current[i]}
            text={item.innerText}
            disableHover
            animation="linear"
            appear
          />
        ))}
      </div>
      <div
        ref={$line}
        className={classes.line}
      />
      <div className={classes.wrapper}>
        <SimpleSplitText
          className={classes.subtitle}
          ref={$subtitle}
          text={subtitle}
          disableHover
          animation="linear"
          appear
        />
        <div className={classes.mediaBox}>
          {mainImg && (
            <SimpleMedia
              ref={$mainImg}
              src={mainImg}
              alt={`${title} ${denomination}`}
              prepareAnimation
            />
          )}
          {altImg && (
            <SimpleMedia
              className={classes.lastImage}
              ref={$altImg}
              src={altImg}
              alt={`${title} ${denomination}`}
              prepareAnimation
            />
          )}
        </div>
      </div>
    </div>
  )
}

export default CoverProduct
